<template>
    <div v-if="errors.length > 0"></div>
    <div class="card shadow mb-2">
        <div class="card-header">
            <div class="row">
                <div class="col">
                    <a href="/qualificationmatrix" class="btn btn-secondary">{{ $trans.get('__JSON__.To qualifications') }}</a>
                </div>
                <div class="col-2">
                    <select v-if="teams" class="form-control" v-model="team_id" name="team_id" id="team_id">
                        <option :value="0" selected>{{ $trans.get("__JSON__.All teams") }}</option>
                        <option v-for="item in teams" :key="item.id" :value="item.id">
                            {{ item.name }}
                        </option>
                    </select>
                </div>
                <div class="col-2">
                    <select v-if="locations" class="form-control" v-model="location_id" name="team_id" id="team_id">
                        <option :value="0" selected>{{ $trans.get("__JSON__.All locations") }}</option>
                        <option v-for="item in locations" :key="item.id" :value="item.id">
                            {{ item.name }}
                        </option>
                    </select>
                </div>
                <div class="col-2">
                    <input class="form-control" :placeholder="$trans.get('__JSON__.Filter name')" type="text" v-model="employeeFilter" id="filter">
                </div>
            </div>
        </div>
    </div>
    <div class="card shadow">
        <div class="card-body">
            <ul class="nav nav-tabs">
                <li v-for="client in clients" class="nav-item"
                    @click="setClient(client.id)">
                    <span role="button" class="nav-link border border-bottom-0 rounded-2" :class="{
                        'active font-weight-bold': client.id == client_id,
                        'text-muted': client.id != client_id,
                    }">{{ client.name }}</span>
                </li>
            </ul>

            <table v-if="projects" class="table table-striped table-bordered panel">
                <thead>
                    <tr>
                        <th>Name / {{ $trans.get('__JSON__.Experience') }}</th>
                            <th role="button" class="text-center" v-for="project in selectedClientProjects"
                                @click="changeSortOrder(project.id)"><span class="text-primary">{{
                                    project.name }}</span>&nbsp;
                                <i v-if="Math.abs(sortExperience) != project.id" class="fa fa-sort"></i>
                                <i v-if="sortExperience == project.id" class="fa fa-sort-up"></i>
                                <i v-if="sortExperience * -1 == project.id" class="fa fa-sort-down"></i>
                            </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="employee in filteredEmployees" :key="employee.id">
                        <td>
                            <div class="employeetaskline grow d-flex">
                                <employee employeelink="1" :employee="employee" />
                            </div>
                        </td>
                            <td v-for="project in selectedClientProjects"
                                :key="employee.id + '-' + project.id">
                                <experience-cell :experience="getEmployeeExperience(employee.id, project.id)" />
                            </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { ref, watch } from "vue";
import getTeams from "../composables/getTeams";
import getLocations from "../composables/getLocations";
import getEmployees from "../composables/getEmployees";
import getClients from "../composables/getClients";
import getProjects from "../composables/getProjects";


export default {
    name: "ExperiencesMatrix",
    props: {
    },
    setup(props) {
        const { teams, teams_error, loadTeams } = getTeams();
        loadTeams();

        const { locations, locations_error, loadLocations } = getLocations();
        loadLocations();

        const { employees, employees_error, loadEmployees } = getEmployees();
        loadEmployees(null, ['experiences', 'employer']);

        const { clients, clients_error, loadClients } = getClients();
        loadClients();

        const { projects, projects_error, loadProjects } = getProjects();
        loadProjects();

        return { teams, locations, employees, clients, projects, loadEmployees };
    },
    computed: {
        filteredEmployees() {
            console.log(this.employeeFilter);
            if (this.employeeFilter == '') {
                return this.employees;
            }

            return this.employees.filter((item) => item.forename.toLowerCase().includes(this.employeeFilter.toLowerCase()) || item.lastname.toLowerCase().includes(this.employeeFilter.toLowerCase()));
        },
        selectedClientProjects() {
            if (this.projects) {
                return this.projects.filter( (item) => item.client_id == this.client_id );
            }
            return null;
        }

    },
    methods: {
        setClient( clientId) {
            this.client_id = clientId;
        },
        formatDate(date) {
            var d = new Date(date),
                month = "" + (d.getMonth() + 1),
                day = "" + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) month = "0" + month;
            if (day.length < 2) day = "0" + day;

            return [year, month, day].join("-");
        },
        getEmployeeExperience(employeeId, projectId) {
            const employee = this.employees.find( (item) => item.id == employeeId );
            if (employee && employee.experiences) {
                return employee.experiences.find( (item) => item.project_id == projectId);
            }
            return null;
        },
        sortEmployeesByExperienceDays( projectId ) {
            const direction = (projectId < 0) ? -1 : 1;
            const searchProjectId = Math.abs(projectId);
            
            this.employees.sort(function (firstEmployee, secondEmployee) {
                if (projectId == 0) {
                    const firstEmployeeName = firstEmployee.lastname + "-" + firstEmployee.forename;
                    const secondEmployeeName = secondEmployee.lastname + "-" + secondEmployee.forename;
                    if (firstEmployeeName > secondEmployeeName) {
                        return 1;
                    }
                    if (firstEmployeeName < secondEmployeeName) {
                        return -1;
                    }
                    return;
                }

                const firstExperience = firstEmployee.experiences.find((item) => item.project_id == searchProjectId);
                const secondExperience = secondEmployee.experiences.find((item) => item.project_id == searchProjectId);

                if (!firstExperience && !secondExperience) {
                    return;
                }

                if (!firstExperience) {
                    return 1 * direction;
                }

                if (!secondExperience) {
                    return -1 * direction;
                }

                if (firstExperience.days < secondExperience.days) {
                    return 1 * direction;
                }

                if (firstExperience.days > secondExperience.days) {
                    return -1 * direction;
                }
            });

        },
        changeSortOrder( experienceId ) {

            if (this.sortExperience == 0 || Math.abs(this.sortExperience) != experienceId) {
                this.sortExperience = experienceId;
                this.sortEmployeesByExperienceDays(this.sortExperience);
                return;
            }

            if (this.sortExperience == experienceId) {
                this.sortExperience = experienceId * -1;
                this.sortEmployeesByExperienceDays(this.sortExperience);
                return;
            }

            if (this.sortExperience == experienceId * -1) {
                this.sortExperience = 0;
                this.sortEmployeesByExperienceDays(this.sortExperience);
                return;
            }
        }
    },
    created() {
    },
    mounted() {
        console.log('clients', this.clients);
    },
    watch: {
        team_id: function (newValue, oldValue) {
            this.loadEmployees([
                ['team_id', newValue],
                ['location_id', this.location_id]
            ], ['experiences', 'employer']);
        },
        location_id: function (newValue, oldValue) {
            this.loadEmployees([
                ['team_id', this.team_id],
                ['location_id', newValue]
            ], ['experiences', 'employer']);
        },
        clients: function (newValue, oldValue) {
            if (oldValue == null) {
                this.client_id = this.clients[0]?.id;
            }

        }
    },
    data() {
        return {
            client_id: 0,
            team_id: 0,
            location_id: 0,
            errors: [],
            employee: null,
            sortExperience: 0,
            employeeFilter: '',
        };
    },
};
</script>

<style scoped lang="scss">
.nav-item:hover {
    background-color: lightgray;
}
/*
th,td {
    border-color: grey !important;
}
*/
</style>
